module.exports = __webpack_public_path__ + "images/emoji/rose.9e3e07987c8bc2e0f515.png";